/* Non-transactional progressive enhancement. */
(() => {
 const brand = document.body.classList.contains('v2-cachorros') ? 'cachorros' : 'davina';
 if (brand === 'davina') document.querySelector('#header-component')?.removeAttribute('transparent');
 // Native links, forms, stock and policy content are never rewritten here.
 const nav = document.querySelector('.avd-nav');
 if (brand === 'cachorros' && nav) {
   const priorities = ['Niña','Niño','Escolar','Mujer','Hombre','Outlet'];
   const items = Array.from(nav.querySelectorAll(':scope > .avd-nav__item'));
   items.sort((a,b) => {
     const rank = el => { const t=el.querySelector('.avd-nav__link')?.textContent.trim();const i=priorities.indexOf(t);return i<0?99:i;};
     return rank(a)-rank(b);
   }).forEach(item => nav.appendChild(item));
 }
 document.documentElement.dataset.v2Design = 'D1-C4-20260911-r2';
})();
